import React from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { BaseUrl, getUserStorageData, showDBdatetime, convertDBdate, timeAgoSinceDate, taskPriorityTextColor } from '../../../includes/Helper';
import { ApiCall } from '../../../includes/Webservice';
import { Row, Col } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner'; 
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import IconButton from 'components/common/IconButton';
const ApiUrlList = () => {
    const navigate = useNavigate();
    const baseurl = BaseUrl();
    const controller = new AbortController();
    const [data, setData] = React.useState([]);
    const [isPageloading, setPageLoad] = React.useState(false);

    React.useEffect(() => {
        onLoad();

        return () => {
            // Anything in here is fired on component unmount.
            //    console.log('Unmount Component')
            controller.abort();
        }

    }, [])

    const onLoad = async () => {
        setPageLoad(true)
         const data = {};
         const result = await ApiCall(baseurl + "/apiurl/list", "post",  1,0, 0, data, '', controller);
        if (result) {
            setPageLoad(false)
            if (result.status == true) {                   
                    setData(result.data)
            } else {
              //  navigate('/');
              toast.info(result.message);
            }
        } else {           
            setPageLoad(false)
            toast.error(`Some error occured, try again later` );
            navigate('/');
        }
    }

    const deleteConfirm = (api_id) => {
        confirmAlert({
            title: 'Confirmation',
            message: 'Are you sure want to delete this record ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteData(api_id)
                },
                {
                    label: 'No',
                    //onClick: () => alert('Click No')
                }
            ]
        });
    };

    const deleteData= async(api_id)=>{ 

        const data = {api_id : api_id};
        const result = await ApiCall(baseurl + "/apiurl/delete", "post",  1,0, 0, data, '', controller);
       if (result) {
         //  setPageLoad(false)
           if (result.status == true) {
                   console.log(result)
                   toast.success(result.message);
                   onLoad()
           } else {
                 toast.error(result.message);
               //navigate('/');
           }
       } else {
          // setPageLoad(false);
           toast.error(`Some error occured, try again later` );
           navigate('/');
       }
    }

    const columns = [
        {
            accessor: 'api_id',
            Header: 'S. No.',
            disableSortBy: true,
            headerProps: { style: { width: '100px' }, className: 'text-900' },
            Cell: rowData => {
                return rowData.row.index + 1;
            }
        },
        {
            accessor: 'api_type',
            Header: 'API Type',
            headerProps: { className: 'text-900' } 
        },
        {
            accessor: 'api_url',
            Header: 'API URL',
            headerProps: { className: 'text-900' } 
        }, 
        {
            accessor: 'api_name',
            Header: 'API Name',
            headerProps: { className: 'text-900' } 
        },
        {  
             accessor: 'is_active',
             Header: 'Active',
             headerProps: { className: 'text-900' },
             Cell: rowData => {
                 const { is_active } = rowData.row.original;
                 return  <p className={is_active == 1 ? `text-success` : `text-danger`} >{is_active == 1 ? `Active` : `Inactive`} </p>
             } 
         }, 
       { 
          accessor: 'updateby',
          Header: 'Update By',
          headerProps: { className: 'text-900' } ,
          Cell: rowData => {
              const { updateby } = rowData.row.original;
              return <div>{!(updateby.first_name) ? 'SUPERADMIN' : updateby.first_name}</div>
             }
      },
       { 
          accessor: 'updatedate',
          Header: 'Update Date',
          headerProps: { className: 'text-900' } ,
          Cell: rowData => {
           const { updatedate } = rowData.row.original;
           return <div>{showDBdatetime(updatedate)}</div>
          }
      },
       { 
        Header: ' ',
        headerProps: { className: 'text-900' },
        Cell: rowData => {
           
            const { _id } = rowData.row.original;
            return <div> <Link to={'/apiurl/edit/' + _id}><FontAwesomeIcon icon={'edit'} /></Link>   &nbsp;&nbsp;&nbsp;<Link   onClick={()=>deleteConfirm(_id)}><FontAwesomeIcon className='text-danger' icon={'trash'} /></Link> 
            </div>
        }
    }
    ];  

    return (
        <>
            <Row className="g-3 mb-3">

                <Col>
                    <FalconComponentCard>
                        <FalconCardHeader
                            title="API List"
                            light={false} 
                            endEl={<Link to="/apiurl/add"><IconButton icon="plus" className='fs-11'  > Add </IconButton></Link> }  
                        />
  {
                        isPageloading ?
                        <div className='text-center py-5'><Spinner animation="grow"   /></div>
                        : 
                        <FalconComponentCard.Body>
 
                            <AdvanceTableWrapper
                                columns={columns}
                                data={data}
                                sortable
                                pagination
                                perPage={25}
                            >
                           
                                <AdvanceTable
                                    table
                                    headerClassName="bg-200 text-nowrap align-middle"
                                    rowClassName="align-middle white-space-nowrap"
                                    tableProps={{
                                        bordered: true,
                                        striped: true,
                                        className: 'fs-10 mb-0 overflow-hidden'
                                    }}
                                />
                                <div className="mt-3">
                                    <AdvanceTablePagination
                                        table
                                    />
                                </div>
                               
                            </AdvanceTableWrapper>
                        </FalconComponentCard.Body>
}
                    </FalconComponentCard>

                </Col>
            </Row>


        </>
    );
};

export default ApiUrlList;
